var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgReviewStar = function SvgReviewStar(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 11 10"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    fillRule: "evenodd",
    d: "M5.37 8.145 2.177 9.823l.61-3.554L.204 3.752l3.568-.519L5.37 0l1.596 3.233 3.568.519-2.582 2.517.61 3.554z"
  })));
};
export default SvgReviewStar;